module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am584-c2c69d34d9bd4c1811a6496ea5062f30.jpg";